import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FaFileDownload } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { HttpClient } from "../Redux/controllers/HttpClient";
import Table, { ActionButton } from "./Table";
import AddButton from "./buttons/AddButton";
import ShareModal from "./Modals/ShareModal";
import { Button } from "@mui/material";
import { CiShare2 } from "react-icons/ci";

const DraftTable = () => {
  const [drafts, setDrafts] = useState([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareableLink, setShareableLink] = useState("");

  const token = useSelector((state) => state?.user?.token);
  const userInfo = useSelector((state) => state?.user?.userInfo?.data?.user);

  useEffect(() => {
    getDrafts();
  }, []);

  const getDrafts = async () => {
    await HttpClient.apiCaller(
      `drafts/?createdBy=${userInfo._id}`,
      "GET",
      null,
      token,
      null
    )
      .then((res) => {
        setDrafts(res?.data.data);
      })
      .catch((err) => console.log(err));
  };

  const handleStatusUpdate = async (draftId, status) => {
    await HttpClient.apiCaller(
      `drafts/${draftId}/status`,
      "PATCH",
      { status },
      token,
      null
    )
      .then(() => {
        getDrafts();
      })
      .catch((err) => console.log(err));
  };

  const handleDelete = async (draftId) => {
    if (window.confirm("Are you sure you want to delete this draft?")) {
      await HttpClient.apiCaller(
        `drafts/delete`, // Adjust the endpoint if necessary
        "DELETE",
        { draftId, createdBy: userInfo._id }, // Pass the payload in the body
        token,
        null
      )
        .then(() => {
          getDrafts(); // Refresh the list after deletion
        })
        .catch((err) => console.log(err));
    }
  };

  const draftTableHeadData = [
    {
      accessorKey: "slno",
      header: "Sl No",
      size: 100,
    },
    {
      accessorKey: "draftId",
      header: "Draft ID",
      size: 150,
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 100,
    },
    {
      accessorKey: "completed",
      header: "Completed %",
      size: 100,
    },
    {
      accessorKey: "lastModified",
      header: "Last Modified",
      size: 150,
    },
    {
      accessorKey: "expiresAt",
      header: "Expires At",
      size: 150,
    },
    {
      accessorKey: "action",
      header: "Action",
      size: 200,
    },
  ];

  const draftTableData = drafts?.map((item, idx) => {
    return {
      slno: idx + 1,
      draftId: item?.draftId,
      completed: item.completedPercentage,
      status: (
        <div
          className={`text-white poppins-medium px-2 py-1 ${
            item.status === "active"
              ? "bg-[#0CAF60]"
              : item.status === "completed"
              ? "bg-[#3B82F6]"
              : "bg-[#6B7280]"
          } w-fit rounded`}
        >
          {item.status}
        </div>
      ),
      lastModified: new Date(item.metadata.lastModified).toLocaleDateString(),
      expiresAt: new Date(item.metadata.expiresAt).toLocaleDateString(),
      action: (
        <div className="flex gap-1">
          <Button
            variant="text"
            size="small"
            onClick={() => {
              setShareableLink(item.shareableLink);
              setShowShareModal(true);
            }}
            sx={{
              minWidth: "auto",
              padding: "4px",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <CiShare2 className="h-4 w-4" />
          </Button>
          <ActionButton
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="frn"
                onClick={() => window.open(item.shareableLink, "_self")}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
              </svg>
            }
          />

          {item.status === "active" && (
            <>
              <ActionButton
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="red"
                    className="frn"
                    onClick={() => handleDelete(item.draftId)}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                    />
                  </svg>
                }
              />
            </>
          )}
        </div>
      ),
    };
  });

  return (
    <>
      <div className="flex xs:flex-col-reverse xs:gap-2 sm:flex-row sm:items-center sm:justify-between mb-5">
        <div>
          <p className="poppins-medium text-lg leading-[21px] text-theme-darkBlue mb-2">
            My Drafts
          </p>
        </div>
      </div>
      <Table tableData={draftTableData} tableHeadData={draftTableHeadData} />
      {showShareModal && (
        <ShareModal
          shareableLink={shareableLink}
          onClose={() => setShowShareModal(false)}
        />
      )}
    </>
  );
};

export default DraftTable;
